import React, { useEffect, useState } from "react";
import { Btn, FormInput, Loader } from "../components";
import { formatDate, Schema } from "../utils";
import { usePaginatedCustomers } from "../utils/hooks/usePaginatedCustomers.ts";
import { faCalendarDays, faReceipt, faUserPen } from "@fortawesome/pro-regular-svg-icons";
import { useIntersect } from "../utils/hooks/useIntersect.ts";
import { useNavigate } from "react-router";
import type { Customer } from "depoto-core";

export const CustomerList: React.FC = () => {
  const navigate = useNavigate()

  const navigateToCustomerCheckout = (tab: 'orders' | 'reservations', c: Customer) => {
    const person = `${c.firstName || ''} ${c.lastName || ''}`.trim()
    const label = [person, c.companyName].filter(Boolean).join(' — ') || c.email || ''
    const params = new URLSearchParams({ customer: String(c.id) })
    if (label) params.set('customerName', label)
    navigate(`/checkout-detail/${tab}?${params.toString()}`)
  }
  const [fulltext, setFulltext] = useState<string>('')
  const [filters, setFilters] = useState<{ fulltext: string }>({ fulltext: '' })
  const { measureRef, isIntersecting } = useIntersect()

  const { customers, loading: areCustomersLoading, loadMore, isLastPage } = usePaginatedCustomers({
    filters: {
      ...filters,
    },
    sort: 'firstName',
    direction: 'ASC',
    schema: Schema.customer.detail,
  })

  // const updateFilters = (key: string, val: string) => {
  //   const nextFilters = {...filters}
  //   nextFilters[key] = val
  //   setFilters(nextFilters)
  // }

  // const clearFilters = () => {
  //   setFilters({
  //     firstName: '',
  //     lastName: '',
  //     email: '',
  //     phone: '',
  //     birthday: '',
  //     companyName: '',
  //     street: '',
  //     zip: '',
  //     city: '',
  //   })
  // }

  const filter = () => setFilters({ fulltext })

  const clearFilters = () => {
    setFulltext('')
    setFilters({ fulltext: '' })
  }

  // todo: detail zakaznika: link do depota. modal na uctence zatim nechat, casem uvidime

  useEffect(() => {
    if (isIntersecting) {
      loadMore()
    }
  }, [isIntersecting])

  return (
    <div className="w-full h-body p-6 flex flex-col overflow-y-auto">
      <div className="scrollable-y bg-white border-b-1 border-solid border-border-light flex-1 rounded-md p-6">
        <div className="flex flex-row mb-4">
          <div className="flex flex-row w-full items-end">
            <div className="flex-1">
              <FormInput label={'Hledat'} className="mb-0!" inputclassName="w-full" value={fulltext} onChange={val => setFulltext(val)} />
            </div>
            <div className="flex flex-row ml-4 items-center">
              <Btn className="btn-primary" children={'Filtrovat'} icon={'fa-search'} onClick={filter} />
              <Btn className="btn-link text-red-500 p-0 leading-none h-auto text-xs ml-auto mb-0.5" children={'Smazat filtry'} icon={'fa-filter-circle-xmark'} onClick={clearFilters} />
            </div>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="table table-zebra w-full">
            <thead>
              <tr>
                <th className="text-left">JMÉNO</th>
                <th className="text-left">PŘÍJMENÍ</th>
                <th className="text-left">EMAIL</th>
                <th className="text-left">TELEFON</th>
                <th className="text-left">DATUM NAROZENÍ</th>
                <th className="text-left">SPOLEČNOST</th>
                <th className="text-right"></th>
              </tr>
            </thead>
            <tbody>
              {customers.length > 0 ? customers.map(c => (
                <tr key={`customer-${c.id}`}>
                  <td>{c.firstName}</td>
                  <td>{c.lastName}</td>
                  <td>{c.email}</td>
                  <td>{c.phone}</td>
                  <td>{c.birthday?.length ? formatDate(new Date(c.birthday), false) : ''}</td>
                  <td>{c.companyName}</td>
                  <td className="text-right">
                    <Btn
                      className="btn-link btn text-primary"
                      icon={faReceipt}
                      children={'Doklady'}
                      onClick={() => navigateToCustomerCheckout('orders', c)}
                    />
                    <Btn
                      className="btn-link btn text-primary"
                      icon={faCalendarDays}
                      children={'Rezervace'}
                      onClick={() => navigateToCustomerCheckout('reservations', c)}
                    />
                    <Btn
                      className="btn-link btn text-primary"
                      icon={faUserPen}
                      children={'upravit'}
                      onClick={() => window.open(`https://app.depoto.cz/customer/${c.id}`)}
                    />
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan={7} className="text-center py-4">
                    {areCustomersLoading ? <Loader /> : <span className="text-base-400">Nic nenalezeno</span>}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {!isLastPage && (
          <div ref={measureRef} className="text-center py-4">
            <span className="text-base-400">next page..</span>
          </div>
        )}
      </div>
    </div>
  )
}
